// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__J5jVw","textArea":"TextArea_textArea__LXdos","error":"TextArea_error__D05Aj"};